import { cva } from 'class-variance-authority';

/**
 * Warianty przycisku ikonowego w osobnym pliku, zeby `IconButton.tsx` eksportowal
 * wylacznie komponent — tego wymaga poprawne dzialanie fast refresh.
 *
 * Wyeksportowane publicznie, bo ten sam wyglad nakladamy tez na `<Link>` z routera
 * (np. ikona konta w pasku gornym), gdzie potrzebujemy semantyki odnosnika.
 */
export const iconButtonVariants = cva(
  [
    'inline-flex shrink-0 items-center justify-center',
    'transition-colors duration-150',
    'disabled:pointer-events-none disabled:opacity-45',
  ],
  {
    variants: {
      variant: {
        secondary:
          'border border-border-strong bg-surface text-fg-muted shadow-xs hover:bg-surface-hover hover:text-fg',
        ghost: 'bg-transparent text-fg-muted hover:bg-surface-hover hover:text-fg',
        danger: 'bg-transparent text-fg-muted hover:bg-danger-50 hover:text-danger-600',
      },
      size: {
        sm: 'size-8 rounded-md [&_svg]:size-4',
        md: 'size-10 rounded-lg [&_svg]:size-[1.125rem]',
        lg: 'size-11 rounded-lg [&_svg]:size-5',
      },
    },
    defaultVariants: {
      variant: 'ghost',
      size: 'md',
    },
  },
);
